import { useEffect, useState } from 'react';
import { handleTrack } from '../../../utils/tracker';
import { categoryIds, categoryName } from '../utils/contants';
import { TGlossary_Card_PROPS } from '../utils/types';
import { Card } from '../../glossary/components/Card';
import { transposeResponse } from '../utils/utils';

export const InfoCard = (): JSX.Element => {
  const [homeData, setHomeData] = useState<TGlossary_Card_PROPS>({});
  const handleEvent = (
    e: React.MouseEvent | React.TouchEvent,
    category: string
  ) => {
    handleTrack({
      label: category,
      obj: e.target,
    });
  };

  useEffect(() => {
    const getHomeData = async () => {
      const recentHomeResponse = await fetch(
        '/mt-routes/api/glossaryData/recentData/'
      );
      const data = await recentHomeResponse.json();
      const refinedData = transposeResponse(data.response);
      setHomeData(refinedData);
    };
    getHomeData();
  }, []);

  return (
    <>
      {Object.keys(homeData).length > 0 &&
        categoryIds?.map((id: string) => {
          return (
            <div
              className="mt-20"
              key={id}
              onClick={(e) => {
                const name = categoryName[id] || 'Info-Card';
                handleEvent(e, name);
              }}
            >
              <h2 className="category-title mb-8 sm:text-s-24 text-s-40">
                {categoryName[id]}
              </h2>
              <Card categoryData={homeData[id] || []} />
            </div>
          );
        })}
    </>
  );
};
